import { create } from "zustand";

import {
  api,
  type ResetPasswordIn,
  type UserCreateIn,
  type UserOut,
  type UserUpdateIn,
} from "@/lib/api";

interface UsersState {
  users: UserOut[];
  selectedUserId: string | null;
  loading: boolean;
  error: string | null;

  fetchUsers: () => Promise<void>;
  setSelectedUserId: (id: string | null) => void;
  createUser: (body: UserCreateIn) => Promise<UserOut>;
  updateUser: (id: string, body: UserUpdateIn) => Promise<UserOut>;
  resetPassword: (id: string, body: ResetPasswordIn) => Promise<void>;
}

export const useUsersStore = create<UsersState>((set, get) => ({
  users: [],
  selectedUserId: null,
  loading: false,
  error: null,

  setSelectedUserId(id) {
    set({ selectedUserId: id });
  },

  async fetchUsers() {
    set({ loading: true, error: null });
    try {
      const users = await api.listUsers();
      set({ users });
    } catch (err) {
      set({ error: err instanceof Error ? err.message : "Erro ao carregar usuários." });
    } finally {
      set({ loading: false });
    }
  },

  async createUser(body) {
    const user = await api.createUser(body);
    await get().fetchUsers();
    return user;
  },

  async updateUser(id, body) {
    const user = await api.updateUser(id, body);
    await get().fetchUsers();
    return user;
  },

  async resetPassword(id, body) {
    await api.resetUserPassword(id, body);
    await get().fetchUsers();
  },
}));
